import { render, staticRenderFns } from "./UserRanking.vue?vue&type=template&id=13b10c60&scoped=true"
import script from "./UserRanking.vue?vue&type=script&lang=js"
export * from "./UserRanking.vue?vue&type=script&lang=js"
import style0 from "./UserRanking.vue?vue&type=style&index=0&id=13b10c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b10c60",
  null
  
)

export default component.exports